module.exports = __webpack_public_path__ + "static/img/zhongchengyao.f1f4d1d.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/zhongchengyao.png
// module id = sJvs
// module chunks = 1